import React from 'react'
import { useStateContext } from '@zambezi/caballo-vivo'

import LinkGroup from './LinkGroup'
import ConsentListSectionHeader from './ConsentListSectionHeader'

import style from './PayYou.module.scss'

export default function PayYou() {
  const groupedLink = useStateContext().getIn([
    'paymeyou',
    'payYouLinks',
    'linksByFriendlyGroup',
  ])

  return (
    <section>
      <div className={style.group}>
        {groupedLink.size > 0 ? (
          <LinkGroup
            groupedLinkData={groupedLink}
            considerPointedBorder
            description={
              'Links expire after 24 hours. Cancel by reviewing each link.'
            }
          />
        ) : (
          <ConsentListSectionHeader
            count={0}
            label={'links'}
            description
            consentType="payMeYou"
            indented
            pointedBorder
          />
        )}
      </div>
    </section>
  )
}
